import React from 'react';
import premiumImg from '../assets/services/premium-service.png';
import armImg from '../assets/services/arm.png';
import legImg from '../assets/services/leg.png';
import bikiniImg from '../assets/services/bikini.png';
import bodyImg from '../assets/services/body.png';
import nailImg from '../assets/services/nail.png';

const categories = [
  {
    name: 'Face',
    image: premiumImg,
    items: [
      'Eyebrows',
      'Upper Lip',
      'Lower Lip',
      'Chin',
      'Forehead',
      'Sideburns',
      'Full Face (includes all of the above)',
    ],
  },
  {
    name: 'Arms & Hands',
    image: armImg,
    items: [
      'Underarms',
      'Half Arms (Upper / Lower)',
      'Full Arms',
      'Hands & Fingers',
    ],
  },
  {
    name: 'Legs & Feet',
    image: legImg,
    items: [
      'Half Legs (Upper / Lower)',
      'Full Legs',
      'Feet & Toes',
    ],
  },
  {
    name: 'Bikini & Body',
    image: bikiniImg,
    items: [
      'Bikini Line',
      'Bikini Full',
      'Brazilian Wax',
      'Hollywood Wax (Full Front + Back)',
      'Buttocks Wax (Optional Add-on)',
      'Privacy, hygiene, and professional care guaranteed.',
    ],
  },
  {
    name: 'Full Body',
    image: bodyImg,
    items: [
      'Back (Upper / Lower / Full)',
      'Stomach (Strip / Full)',
      'Chest',
      'Shoulders',
      'Full Body Wax (Face + Arms + Legs + Underarms + Bikini)',
    ],
  },
  {
    name: 'Nail Art',
    image: nailImg,
    items: [
      'Gel Manicure & Pedicure',
      'Custom Nail Art Design',
      'Nail Extensions & Shaping',
    ],
  },
];

const Services = () => {
  return (
    <section id="services" className="services section">
      <div className="container">
        <h2>Our Services</h2>
        <div className="service-grid">
          {categories.map((category) => (
            <div className="service-card" key={category.name}>
              <img
                src={category.image}
                alt={category.name}
                className="service-image"
              />
              <h3>{category.name}</h3>
              <ul>
                {category.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;